export default __webpack_public_path__ + "fb6c3e632d9501ddb9dbd097ace2ad66.png";